(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      /* Bind every method that gets used as a listener or callback once here — passing
         `.bind(this)` inline creates a fresh function each call that the matching
         removeEventListener can never find, which is how the old code leaked a listener
         on every matchMedia change. */
      this._onMediaChange = this.setHeaderHeight.bind(this);
      this._onResizeObserved = this.onHeaderResize.bind(this);
      this._onScrollShared = this.onScroll.bind(this);
      this._onHeaderDrawerOpened = this.onHeaderDrawerOpened.bind(this);
      this._onHeaderDrawerClosed = this.onHeaderDrawerClosed.bind(this);
      this._hideHeaderOnScrollUp = () => { this.preventReveal = true; };
      this._scrollBusUnsubscribe = null;
      this._scrollFallbackHandler = null;
      this._resizeObserver = null;
      this._intersectionObserver = null;
      this._mediaQuery = null;
    }

    connectedCallback() {
      this.header = this.closest('.section-header') || document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = { top: 0, bottom: 0 };
      this._cachedHeaderHeight = 0;

      this.setHeaderHeight();

      /* Same listener reference on add + remove — the old code used an anonymous
         .bind(this) which made the removeEventListener unreachable. */
      this._mediaQuery = window.matchMedia('(max-width: 990px)');
      this._mediaQuery.addEventListener('change', this._onMediaChange);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this._scrollQueued = false;
      this._pendingScrollY = 0;

      this.addEventListener('preventHeaderReveal', this._hideHeaderOnScrollUp);

      /* Prefer the shared scroll bus (one listener, one rAF per frame for all state
         machines on the page). Fall back to a private passive listener if the bus
         script failed to run — keeps the component functional in isolation. */
      if (window.ReignScrollBus && typeof window.ReignScrollBus.subscribe === 'function') {
        this._scrollBusUnsubscribe = window.ReignScrollBus.subscribe(this._onScrollShared);
      } else {
        this._scrollFallbackHandler = () => {
          if (this._scrollQueued) return;
          this._scrollQueued = true;
          requestAnimationFrame(() => {
            this._scrollQueued = false;
            this._onScrollShared(window.scrollY || document.documentElement.scrollTop);
          });
        };
        window.addEventListener('scroll', this._scrollFallbackHandler, { passive: true });
      }

      document.documentElement.addEventListener('shopify-theme:header-drawer:opened', this._onHeaderDrawerOpened);
      document.documentElement.addEventListener('shopify-theme:header-drawer:closed', this._onHeaderDrawerClosed);

      /* ResizeObserver owns recomputing cached layout values (height + bounds).
         Scroll path never calls getBoundingClientRect. */
      if (typeof ResizeObserver !== 'undefined') {
        this._resizeObserver = new ResizeObserver(this._onResizeObserved);
        this._resizeObserver.observe(this);
      }

      this.createObserver();
    }

    /** Recompute cached header height + bounds whenever the header wrapper resizes
     *  (e.g. promo strip appears, font loads, mega-menu opens). The old code only
     *  captured bounds ONCE via IntersectionObserver then threw the observer away,
     *  which left stale numbers behind after any layout change. */
    onHeaderResize() {
      this.setHeaderHeight();
      this.refreshHeaderBounds();
    }

    refreshHeaderBounds() {
      /* When the sticky-header element is itself position: fixed (e.g. transparent-home
         mode pins .header-wrapper), getBoundingClientRect().top is viewport-relative
         (~0) so adding scrollY to it produces a bounds value that tracks scrollY —
         the state machine would then think "past the header" is wherever the user
         currently is. Instead, when fixed, treat the header as occupying the first
         `offsetHeight` pixels of the viewport; scroll-down past that height starts
         the hide behavior, which matches user expectation. */
      const cs = typeof window.getComputedStyle === 'function' ? window.getComputedStyle(this) : null;
      if (cs && cs.position === 'fixed') {
        this.headerBounds = { top: 0, bottom: this.offsetHeight };
        return;
      }
      const rect = this.getBoundingClientRect();
      const scrollY = window.scrollY || document.documentElement.scrollTop;
      this.headerBounds = {
        top: rect.top + scrollY,
        bottom: rect.bottom + scrollY
      };
    }

    onHeaderDrawerOpened() {
      if (this.headerIsAlwaysSticky) return;
      requestAnimationFrame(this.reveal.bind(this));
    }

    onHeaderDrawerClosed() {
      if (this.headerIsAlwaysSticky) return;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.currentScrollTop = scrollTop;
      if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      } else if (scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.hide.bind(this));
      } else {
        requestAnimationFrame(this.reveal.bind(this));
      }
    }

    setHeaderHeight() {
      /* Defer the DOM read/write into an rAF so consecutive callers (matchMedia
         change + RO + initial connect) don't each trigger a synchronous layout. */
      if (this._heightRafQueued) return;
      this._heightRafQueued = true;
      requestAnimationFrame(() => {
        this._heightRafQueued = false;
        if (!this.header) return;
        const h = this.offsetHeight;
        if (h === this._cachedHeaderHeight) return;
        this._cachedHeaderHeight = h;
        document.documentElement.style.setProperty('--header-height', `${h}px`);
      });
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this._hideHeaderOnScrollUp);
      if (this._scrollBusUnsubscribe) {
        this._scrollBusUnsubscribe();
        this._scrollBusUnsubscribe = null;
      }
      if (this._scrollFallbackHandler) {
        window.removeEventListener('scroll', this._scrollFallbackHandler);
        this._scrollFallbackHandler = null;
      }
      if (this._mediaQuery) {
        this._mediaQuery.removeEventListener('change', this._onMediaChange);
        this._mediaQuery = null;
      }
      if (this._resizeObserver) {
        this._resizeObserver.disconnect();
        this._resizeObserver = null;
      }
      if (this._intersectionObserver) {
        this._intersectionObserver.disconnect();
        this._intersectionObserver = null;
      }
      document.documentElement.removeEventListener('shopify-theme:header-drawer:opened', this._onHeaderDrawerOpened);
      document.documentElement.removeEventListener('shopify-theme:header-drawer:closed', this._onHeaderDrawerClosed);
    }

    createObserver() {
      /* Seed bounds from the sticky-header element (not the outer .section-header),
         which matches the visible bar and avoids dead zones with transparent home. */
      if (this._intersectionObserver) this._intersectionObserver.disconnect();
      this._intersectionObserver = new IntersectionObserver((entries, observer) => {
        observer.disconnect();
        this._intersectionObserver = null;
        this.refreshHeaderBounds();
      });
      this._intersectionObserver.observe(this);
    }

    /**
     * Called from the shared scroll bus with the scrollY value already read once
     * at the top of the frame. We never read scrollY or call getBoundingClientRect
     * here — all cached via refreshHeaderBounds() on RO / MM.
     */
    onScroll(scrollY) {
      const scrollTop = typeof scrollY === 'number' ? scrollY : (window.pageYOffset || document.documentElement.scrollTop);

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      const headerWrapper = document.querySelector('.header-wrapper');
      if (headerWrapper && headerWrapper.preventHide) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('animate', 'shopify-section-header-sticky', 'shopify-section-header-hidden');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
